export type QueueItemStatus = "pending" | "review" | "done" | "failed";
export type ImportQueueItem = { id: string; requestId: string; name: string; size: number; file?: File; status: QueueItemStatus; inserted: number; skipped: number; error?: string; reviewReady?: boolean };
export type ImportQueue = { id: string; items: ImportQueueItem[]; currentId?: string; updatedAt: string };
export function createImportQueue(files: File[]): ImportQueue {
  return { id: crypto.randomUUID(), updatedAt: new Date().toISOString(), items: files.map((file) => ({
    id: crypto.randomUUID(), requestId: crypto.randomUUID(), name: file.name, size: file.size, file, status: "pending", inserted: 0, skipped: 0,
  })) };
}
export function updateQueueItem(queue: ImportQueue, id: string, change: Partial<ImportQueueItem>): ImportQueue {
  return { ...queue, updatedAt: new Date().toISOString(), items: queue.items.map((item) => item.id === id ? { ...item, ...change } : item) };
}
export function nextQueueItem(queue: ImportQueue) { return queue.items.find((item) => item.status === "pending"); }
export function canResumeQueueItem(queue: ImportQueue, id: string) {
  const currentReview = queue.items.find(item => item.reviewReady && item.status !== "done");
  if (currentReview) return currentReview.id === id;
  const target = queue.items.find(item => item.id === id);
  return Boolean(target?.file && (target.status === "failed" || nextQueueItem(queue)?.id === id));
}
export function queueSummary(queue: ImportQueue) {
  return queue.items.reduce((total, item) => ({ ...total,
    done: total.done + Number(item.status === "done"), failed: total.failed + Number(item.status === "failed"),
    inserted: total.inserted + item.inserted, skipped: total.skipped + item.skipped,
  }), { total: queue.items.length, done: 0, failed: 0, inserted: 0, skipped: 0 });
}
